import { render, staticRenderFns } from "./LayoutPurchase.vue?vue&type=template&id=371c1318&scoped=true&"
import script from "./LayoutPurchase.vue?vue&type=script&lang=js&"
export * from "./LayoutPurchase.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPurchase.vue?vue&type=style&index=0&id=371c1318&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c1318",
  null
  
)

export default component.exports